import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { isAdminLoggedIn } from '../services/adminAuth';
import AdminDashboard from './AdminDashboard';
import AdminLayout from './AdminLayout';
import AdminLogin from './AdminLogin';
import CategoriesPage from './CategoriesPage';
import QuestionsPage from './QuestionsPage';
import SettingsPage from './SettingsPage';

function Protected({ children }) {
  if (!isAdminLoggedIn()) return <Navigate to="/admin" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      <Route path="/dashboard"  element={<Protected><AdminDashboard /></Protected>} />
      <Route path="/categories" element={<Protected><CategoriesPage /></Protected>} />
      <Route path="/questions"  element={<Protected><QuestionsPage /></Protected>} />
      <Route path="/settings"   element={<Protected><SettingsPage /></Protected>} />
      <Route path="*"           element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
